module.exports = __webpack_public_path__ + "img/Kosta.287e31da.jpg";